export default "__VITE_ASSET__DWyCSKWh__"